import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import styles from './styles';
/**
 * @slot avatar-icon - The avatar's icon (amityeko-icon expected). It only show no image or initials.
 *
 * @csspart base - The avatar's base container.
 * @csspart initials - The avatar's initials.
 * @csspart icon - The avatar's icon
 * @csspart image - The avatar's image
 */
export default class AmityekoAvatar extends LitElement {
    constructor() {
        super(...arguments);
        this.shape = 'circle';
        this.label = '';
        this.image = '';
        this.initials = '';
        this.avatarSize = '40px';
    }
    render() {
        return html `
      <div
        part="base"
        class=${classMap({
            avatar: true,
            'avatar--circle': this.shape === 'circle',
            'avatar--rounded': this.shape === 'rounded',
            'avatar--square': this.shape === 'square',
        })}
        aria-label=${this.label}
        style=${styleMap({
            '--private-avatar-size': this.avatarSize,
            '--private-avatar-bg-color': this.customBgColor,
        })}
      >
        ${this.image
            ? html ` <img part="image" class="avatar-image" src="${this.image}" alt="" /> `
            : html `${this.initials
                ? html ` <div part="initials" class="avatar-initials">${this.initials}</div> `
                : html `
                  <div part="icon" class="avatar-icon">
                    <slot name="avatar-icon"></slot>
                  </div>
                `}`}
      </div>
    `;
    }
}
AmityekoAvatar.styles = styles;
__decorate([
    property()
], AmityekoAvatar.prototype, "shape", void 0);
__decorate([
    property()
], AmityekoAvatar.prototype, "label", void 0);
__decorate([
    property()
], AmityekoAvatar.prototype, "image", void 0);
__decorate([
    property()
], AmityekoAvatar.prototype, "initials", void 0);
__decorate([
    property()
], AmityekoAvatar.prototype, "avatarSize", void 0);
__decorate([
    property()
], AmityekoAvatar.prototype, "customBgColor", void 0);
if (!customElements.get('amityeko-avatar')) {
    customElements.define('amityeko-avatar', AmityekoAvatar);
}
//# sourceMappingURL=index.js.map